import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import NotFound from './components/pages/NotFound';
import Login from './components/pages/Login';
import App from './App';
import Gywm from "./components/gywm";
import LoginCopy from './components/pages/LoginCopy';

export default () => (
    <Router>
        <Switch>
            <Route exact path="/" component={Login} />
            <Route path="/feima" component={App} />
            <Route path="/bizheng" component={LoginCopy} />
            <Route path="/404" component={NotFound} /> 
            <Route component={NotFound} />
        </Switch>
    </Router>
)


// WEBPACK FOOTER //
// ./src/Page.js